<template>
  <div
    v-click-outside="turnOffEditMode"
    class="d-flex flex-column"
    @click="onClick"
    @click.right="onRightClick"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <NodeDeleteButton v-if="isEditModeActive" @onClick="deleteNode" />

    <NodeTitle :mdi-icon="mdiIcon" :name="name" />

    <NodeContent>
      <component :is="nodeContentToDisplay" :node-id="nodeId" />

      <v-slide-y-transition>
        <div
          v-if="hover"
          class="caption text--secondary font-italic d-flex align-center"
          style="position: absolute; bottom: -25px; left: 0"
        >
          <v-icon
            small
            class="pr-1"
            v-text="isEditModeActive ? 'mdi-content-save' : 'mdi-mouse'"
          />
          {{ isEditModeActive ? 'Saving automatically' : 'Right click to edit' }}
        </div>
      </v-slide-y-transition>
    </NodeContent>
  </div>
</template>

<script>
  import store from '@/store'
  import EditSplitterNode from '@/components/Node/SplitterNode/EditSplitterNode'
  import NodeTitle from '@/components/Node/NodeTitle'
  import NodeDeleteButton from '@/components/Node/NodeDeleteButton'
  import EditSenderNode from '@/components/Node/SenderNode/EditSenderNode'
  import NodeContent from '@/components/Node/NodeContent'
  import ReadOnlySplitterNode from '@/components/Node/SplitterNode/ReadOnlySplitterNode'
  import ReadOnlySenderNode from '@/components/Node/SenderNode/ReadOnlySenderNode'
  import { mapActions } from 'vuex'

  export default {
    name: 'Node',
    components: { ReadOnlySenderNode, ReadOnlySplitterNode, NodeContent, EditSenderNode, NodeDeleteButton, NodeTitle, EditSplitterNode },
    props: {
      name: {
        type: String,
        default: ''
      },
      mdiIcon: {
        type: String,
        default: ''
      },
    },
    data: () => ({
      canDeleteButtonBeDisplayed: false,
      isEditModeActive: false,
      hover: false,
      nodeId: null
    }),
    computed: {
      nodeContentToDisplay () {
        switch (this.name) {
          case 'Split':
            return this.isEditModeActive ? EditSplitterNode : ReadOnlySplitterNode
          case 'Send':
            return this.isEditModeActive ? EditSenderNode : ReadOnlySenderNode
          default:
            // Can't found content of the node "${this.name}"
            return null
        }
      },
    },
    methods: {
      ...mapActions([ 'deleteNodeAndCheckIfDiagramIsEmpty' ]),
      turnOffEditMode () {
        this.isEditModeActive = false
      },
      deleteNode () {
        store.dispatch('deleteNodeAndCheckIfDiagramIsEmpty')
      },
      setNodeId () {
        this.nodeId = store.state.selectedNode
      },
      onRightClick () {
        this.isEditModeActive = !this.isEditModeActive

        // Set nodeId if is still null
        if (!this.nodeId) this.setNodeId()
      },
      onClick () {
        // Set nodeId if is still null
        if (!this.nodeId) this.setNodeId()
      }
    },
  }
</script>

<style scoped>

</style>
